import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-components',
  template: `
    <p>
      components works!
    </p>
  `,
  styles: [
  ]
})
export class ComponentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
